import React from "react";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUITextField from "@mui/material/TextField";
import { getClassName } from "@sscs/utils";
import Button from "../Button/Button";
import { CopyIcon } from "../index";
import styles from "./copyTextContainer.module.scss";
const CopyTextContainer = ({ text, name, id, tooltipTitle, multiline = true, endAdornment, className, onCopyToClipboard, }) => {
    const copyToClipboard = async () => {
        if (text) {
            await navigator.clipboard.writeText(text);
            onCopyToClipboard === null || onCopyToClipboard === void 0 ? void 0 : onCopyToClipboard();
        }
    };
    const textFieldClassName = getClassName(styles["copy-text-container"], { [styles["copy-text-container--single-line"]]: !multiline }, className);
    return (React.createElement(MUITextField, { className: textFieldClassName, name: name !== null && name !== void 0 ? name : "copy-text-container", id: id !== null && id !== void 0 ? id : `copy-text-container`, multiline: multiline, minRows: multiline ? 2 : 1, maxRows: multiline ? 2 : 1, fullWidth: true, onFocus: (event) => {
            event.target.select();
        }, value: text, slotProps: {
            input: {
                readOnly: true,
                startAdornment: (React.createElement(MUIInputAdornment, { position: "start" },
                    React.createElement(Button, { tooltipTitle: tooltipTitle, color: "primary", onClick: copyToClipboard },
                        React.createElement(CopyIcon, null),
                        "Copy"))),
                endAdornment: !endAdornment ? undefined : (React.createElement(MUIInputAdornment, { position: "end" },
                    React.createElement(Button, { tooltipTitle: tooltipTitle, color: "primary", onClick: copyToClipboard, className: styles["end-adornment-button"] }, endAdornment))),
            },
        } }));
};
export default CopyTextContainer;
//# sourceMappingURL=CopyTextContainer.js.map